module.exports = __webpack_public_path__ + "img/ROMAPI_CG.df7e6259.png";